<table class="table-auto w-full border-collapse">
  <thead class="rounded-[7px]">
      <tr class="rounded-[7px] overflow-hidden">
          <th style="background-color: rgba(228, 229, 229, 0.12)" class="px-[7px] py-0.5 text-left text-white/50 text-[12px] font-normal leading-[1.4] border-none rounded-tl-lg rounded-bl-lg" [ngClass]="currentLang === 'ru' ? 'w-[46%]' : 'w-[58%]'">{{ 'advance_aml_protection_triggers.text1' | translate }}</th>
          <th style="background-color: rgba(228, 229, 229, 0.12)" class="px-[7px] py-0.5 text-left text-white/50 text-[12px] font-normal leading-[1.4] border-none rounded-tr-lg rounded-br-lg" [ngClass]="currentLang === 'ru' ? 'w-[54%]' : 'w-[42%]'">{{ 'advance_aml_protection_triggers.text2' | translate }}</th>
      </tr>
  </thead>
  <tbody class="block max-h-[422px] overflow-y-auto before:block before:h-[5px]">
    @for (trigger of triggerList; track $index) {
      <tr class="border-b border-white border-opacity-5 last:border-none">
        <td class="py-1 pl-2 pr-1 text-[12px] text-white leading-[1.2]" [ngClass]="currentLang === 'ru' ? 'w-[46%]' : 'w-[58%]'">
          @if (currentLang === 'ru') {
            {{trigger.nameRu}}
          }
          @else {
            {{trigger.nameEn}}
          }
            <!-- TODO Prev version Tooltip -->
            <!-- <button>
                <app-info class="w-[14px] h-[14px]" [currentColor]="'text-white opacity-30'" text="---"></app-info>
            </button> -->
        </td>
        <td class="py-1 pl-1 pr-2" [ngClass]="currentLang === 'ru' ? 'w-[54%]' : 'w-[42%]'">
          <div class="flex justify-between gap-1 w-full">
            <ng-container [ngTemplateOutlet]="statusTemplate"></ng-container>
          </div>
        </td>
      </tr>
      <ng-template #statusTemplate>
        <span class="label green" [class.active]="trigger.risk === 'LOW'">{{ 'pages.reports.common.LOW' | translate }}</span>
        <span class="label yellow" [class.active]="trigger.risk === 'MEDIUM'">{{ 'pages.reports.common.MEDIUM' | translate }}</span>
        <span class="label red" [class.active]="trigger.risk === 'HIGH'">{{ 'pages.reports.common.HIGH' | translate }}</span>
      </ng-template>
    }
  </tbody>
</table>
